<div class="flex flex-col justify-start w-full h-full max-w-md mx-auto">
  <ng-content></ng-content>
</div>
